import styled, { css } from 'styled-components';
import { type ListItemProps, ListInlineSeparator } from './ListInline.typed';

const ListInline = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const ListItem = styled.li<ListItemProps>`
  ${({ theme, fontSize }) => theme.fontSize[fontSize]}
  display: flex;
  align-items: center;
  color: ${({ theme, separatorColour }) => theme.colors[separatorColour]};
  ${({ theme, separator, separatorColour }) =>
    separator
      ? css`
          &:not(:last-child) {
            &:after {
              content: '';
              ${separator === ListInlineSeparator.BULLET &&
              css`
                width: 4px;
                height: 4px;
                margin: 0 ${theme.spacing.S8};
                background: ${theme.colors[separatorColour]};
                border-radius: 50%;
              `}
              ${separator === ListInlineSeparator.LINE &&
              css`
                align-self: stretch;
                width: 1px;
                margin: 0 ${theme.spacing.M16};
                background: ${theme.colors[separatorColour]};
              `}
            }
          }
        `
      : css`
          &:not(:last-child) {
            margin-right: ${theme.spacing.S8};
          }
        `}
`;

export { ListInline, ListItem };
